import React, { type FC } from 'react';
import classnames from 'classnames';

import styles from 'theme/pages/wise/WiseProduct/components/WiseProductItem/WiseProductItemSkeleton.module.scss';

export type WiseProductItemSkeletonProps = {
  className?: string;
};

/** Placeholder karty produktu (260×465) na czas ładowania w karuzelach Wise. */
export const WiseProductItemSkeleton: FC<WiseProductItemSkeletonProps> = ({ className }) => (
  <div
    className={classnames(
      styles.root,
      className,
      'StylePath-Pages-Wise-WiseProduct-components-WiseProductItemSkeleton'
    )}
    aria-hidden>
    <div className={styles.imageZone}>
      <div className={styles.imagePlaceholder} />
    </div>
    <div className={styles.body}>
      <div className={styles.line} />
      <div className={styles.line} />
      <div className={styles.line} />
    </div>
  </div>
);

export default WiseProductItemSkeleton;
